import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCurrentUser } from "./redux/userSlice";

import {
  // BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Home } from "./components/frontpage/Home";
import Layout from "./components/page/gamePage/Layout/Layout";
import HeaderOnlyLayout from "./components/page/gamePage/Layout/HeaderOnlyLayout";
import Promotions from "./components/page/gamePage/Promo/Promotions";
import MobileFooter from "./components/footer/MobileFooter";
import CricketTournament from "./components/page/gamePage/cricket/Main";
import Football from "./components/page/gamePage/football/Football";
import EnglishPremmier from "./components/page/gamePage/football/englishpremmier/EnglishPremmier";
import ParentPage from "./components/userAuth/ParentPage";
import ErrorPage from "./components/frontpage/ErrorPage";
import BallByBall from "./components/page/gamePage/cricket/ballbyball/BallByBall";
import WBBLPage from "./components/page/gamePage/cricket/wbbl/WBBLPage";
import TheAshes from "./components/page/gamePage/cricket/TheAshes/TheAshes";
import { AbudhabiT } from "./components/page/gamePage/cricket/abudhabi/AbudhabiT";
import { InternationalT } from "./components/page/gamePage/cricket/international/InternationalT";
import { NepalPreLeague } from "./components/page/gamePage/cricket/nepalpre/NepalPreLeague";
import { SouthAfrica } from "./components/page/gamePage/cricket/southAfricamatch/SouthAfrica";
import { TestMatch } from "./components/page/gamePage/cricket/testMatch/TestMatch";
import Election from "./components/page/gamePage/election/Election";
import Inplay from "./components/page/gamePage/mobilefooter/inplay/Inplay";
import Sports from "./components/page/gamePage/mobilefooter/sports/Sports";
import UserDashboard from "./components/userAuth/user/UserDashboard";
import BetHistory from "./components/userAuth/user/Bethistory";
import CasinoPage from "./components/page/gamePage/casino/CasinoPage";
import LiveCasino from "./components/page/gamePage/casino/CasinoPage";
import GameLaunchPage from "./components/page/gamePage/casino/GameLaunchPage";
import ProvidersPage from "./components/page/gamePage/providers/ProvidersPage";
import ProviderSinglePage from "./components/page/gamePage/providers/ProviderSinglePage";
import SlotsPage from "./components/page/gamePage/slots/SlotsPage";
import CrashPage from "./components/page/gamePage/crash/CrashPage";
import FishingPage from "./components/page/gamePage/fishing/FishingPage";
import { UserDetails } from "./components/userAuth/user/Dashboard";
import TransactionHistory from "./components/userAuth/user/TransactionHistory";
import Deposit from "./components/userAuth/user/Deposit";
import DepositStatus from "./components/userAuth/user/DepositStatus";
import Withdrawal from "./components/userAuth/user/Withdrawal";
import LoginPage from "./components/userAuth/loginpage/LoginPage";
import ProtectedRoute from "./routes/ProtectedRoute";
import PublicRoute from "./routes/PublicRoute";
import ScrollToTop from "./components/utils/ScrollToTop";
import LuckyPage from "./components/page/gamePage/dedicated/LuckyPage";
import BTiPage from "./components/page/gamePage/dedicated/BTiPage";
import UnitedSportsPage from "./components/page/gamePage/dedicated/UnitedSportsPage";
import CasinoHome from "./components/page/CasinoHome";
import SearchPage from "./components/page/gamePage/SearchPage";
import ResetPassword from "./components/userAuth/ResetPassword";
// import Promotions from "./components/page/gamePage/Promo/Promotions";

function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { token, user, loading } = useSelector((state) => state.user);

  useEffect(() => {
    // Cleanup legacy localStorage data
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  }, []);

  useEffect(() => {
    if (token && !user && !loading) {
      dispatch(fetchCurrentUser());
    }
  }, [token, user, loading, dispatch]);

  return (
    <>
      <ScrollToTop />
      {/* <Router> */}
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Layout>
                <LoginPage />
              </Layout>
            </PublicRoute>
          }
        />
        <Route
          path="/user-reset-pass"
          element={
            // <PublicRoute>
            <Layout>
              <ResetPassword />
            </Layout>
            // </PublicRoute>
          }
        />
        <Route
          path="/casinogame"
          element={
            <Layout>
              <CasinoHome />
            </Layout>
          }
        />

        <Route
          path="/"
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />
        <Route
          path="/"
          element={
            <Layout>
              <Inplay />
            </Layout>
          }
        />
        {/* <Route
          path="/sports"
          element={
            <Layout>
              <Sports />
            </Layout>
          }
        /> */}
        <Route
          path="/promos"
          element={
            <ProtectedRoute>
              <Layout>
                <Promotions />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/cricket"
          element={
            <Layout>
              <CricketTournament />
            </Layout>
          }
        />
        <Route
          path="/cricket/ballbyball"
          element={
            <Layout>
              <BallByBall />
            </Layout>
          }
        />
        <Route
          path="/cricket/wbbl"
          element={
            <Layout>
              <WBBLPage />
            </Layout>
          }
        />
        <Route
          path="/cricket/the-ashes"
          element={
            <Layout>
              <TheAshes />
            </Layout>
          }
        />
        <Route
          path="/cricket/abudhabi"
          element={
            <Layout>
              <AbudhabiT />
            </Layout>
          }
        />
        <Route
          path="/cricket/international"
          element={
            <Layout>
              <InternationalT />
            </Layout>
          }
        />
        <Route
          path="/cricket/nepal-pre-league"
          element={
            <Layout>
              <NepalPreLeague />
            </Layout>
          }
        />
        <Route
          path="/cricket/south-africa"
          element={
            <Layout>
              <SouthAfrica />
            </Layout>
          }
        />
        <Route
          path="/cricket/test-match"
          element={
            <Layout>
              <TestMatch />
            </Layout>
          }
        />
        <Route
          path="/casino"
          element={
            // <ProtectedRoute>
            <Layout type="full-width">
              <CasinoPage />
            </Layout>
            // </ProtectedRoute>
          }
        />
        <Route
          path="/football"
          element={
            <Layout>
              <Football />
            </Layout>
          }
        />
        <Route
          path="/football/englishpremmier"
          element={
            <Layout>
              <EnglishPremmier />
            </Layout>
          }
        />
        <Route
          path="/ball-by-ball"
          element={
            <Layout>
              <BallByBall />
            </Layout>
          }
        />
        <Route
          path="/election"
          element={
            <Layout>
              <Election />
            </Layout>
          }
        />
        <Route
          path="/user-dashboard"
          element={
            <ProtectedRoute>
              {" "}
              <Layout>
                <UserDashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-details"
          element={
            <ProtectedRoute>
              <Layout>
                <UserDetails />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/transactions"
          element={
            <ProtectedRoute>
              <Layout>
                <TransactionHistory />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/deposit"
          element={
            <ProtectedRoute>
              <Layout>
                <Deposit />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/deposit-status/:orderId"
          element={
            <Layout>
              <DepositStatus />
            </Layout>
          }
        />
        <Route
          path="/withdrawal"
          element={
            <ProtectedRoute>
              <Layout>
                <Withdrawal />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/user-bet-history"
          element={
            <ProtectedRoute>
              <Layout>
                <BetHistory />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/error"
          element={
            <ProtectedRoute>
              <Layout>
                <ErrorPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/games/:slug"
          element={
            <Layout type="full-width">
              <GameLaunchPage />
            </Layout>
          }
        />
        <Route
          path="/providers"
          element={
            <Layout type="full-width">
              <ProvidersPage />
            </Layout>
          }
        />
        <Route
          path="/providers/:slug"
          element={
            <Layout type="full-width">
              <ProviderSinglePage />
            </Layout>
          }
        />
        <Route
          path="/search"
          element={
            <Layout type="full-width">
              <SearchPage />
            </Layout>
          }
        />
        <Route
          path="/slots"
          element={
            // <ProtectedRoute>
            <Layout type="full-width">
              <SlotsPage />
            </Layout>
            // </ProtectedRoute>
          }
        />
        <Route
          path="/crash"
          element={
            // <ProtectedRoute>
            <Layout type="full-width">
              <CrashPage />
            </Layout>
            // </ProtectedRoute>
          }
        />
        <Route
          path="/fishing"
          element={
            // <ProtectedRoute>
            <Layout type="full-width">
              <FishingPage />
            </Layout>
            // </ProtectedRoute>
          }
        />
        <Route
          path="/sports"
          element={
            <HeaderOnlyLayout>
              <LuckyPage />
            </HeaderOnlyLayout>
          }
        />
        <Route
          path="/lucky"
          element={
            <HeaderOnlyLayout>
              <LuckyPage />
            </HeaderOnlyLayout>
          }
        />
        <Route
          path="/bti"
          element={
            <ProtectedRoute>
              <HeaderOnlyLayout>
                <BTiPage />
              </HeaderOnlyLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/united-sports"
          element={
            <ProtectedRoute>
              <HeaderOnlyLayout>
                <UnitedSportsPage />
              </HeaderOnlyLayout>
            </ProtectedRoute>
          }
        />

        {/* Add routes for all other links like /election, /tennis, etc. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {/* </Router> */}
      {/* <Footer /> */}
    </>
  );
}

export default App;
